import React from 'react';
import { Button as But } from 'react-bootstrap'

const Button = (props) => {
    return(
        <div className={props.cname}>
            <But onClick={props.click} variant={props.varient}>{props.value}</But>
        </div>
    )
}
        
export default Button;
